import { render, staticRenderFns } from "./BuildAdd.vue?vue&type=template&id=8a0911a8&scoped=true&"
import script from "./BuildAdd.vue?vue&type=script&lang=js&"
export * from "./BuildAdd.vue?vue&type=script&lang=js&"
import style0 from "./BuildAdd.vue?vue&type=style&index=0&id=8a0911a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0911a8",
  null
  
)

export default component.exports